<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Recherche par IMEI</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
      </search-filter>
      <div class="flex">
      </div>
    </div>
    <div v-if="repairs != null && repairs.data.length !== 0" class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">N° Order</th>
          <th class="px-6 pt-6 pb-4">Model</th>
          <th class="px-6 pt-6 pb-4">imei</th>
          <th class="px-6 pt-6 pb-4">Panne</th>
          <th class="px-6 pt-6 pb-4">Garantie</th>
          <th class="px-6 pt-6 pb-4">Agence</th>
          <th class="px-6 pt-6 pb-4">Status</th>
          <th class="px-6 pt-6 pb-4">utilisateur</th>
          <th class="px-6 pt-6 pb-4">Date reception</th>
        </tr>
        <tr v-for="repair in repairs.data" :key="repair.id" class="hover:bg-gray-100 focus-within:bg-gray-100"
            :class="{'bg-red-400': repair.irreparable, 'bg-green-300': repair.repaired}">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', repair.id)" tabindex="-1">
            {{ repair.id }}
                <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', repair.id)" tabindex="-1">
            {{ repair.model }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', repair.id)" tabindex="-1">
                {{ repair.imei }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', repair.id)" tabindex="-1">
                {{ repair.malfunction }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', repair.id)" tabindex="-1">
                {{ repair.warranty }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', repair.id)" tabindex="-1">
                {{ repair.agency }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', repair.id)" tabindex="-1">
                {{ repair.status }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', repair.id)" tabindex="-1">
                {{ repair.user }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', repair.id)" tabindex="-1">
                {{ repair.created_at }}
            </inertia-link>
          </td>
        </tr>
      </table>
    </div>
    <pagination v-if="repairs != null" :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Pagination from '@/Shared/Pagination'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'

export default {
  metaInfo: {title: 'Recherche'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
  },
  props: {
    filters: Object,
    repairs: Object,
  },
  data() {
    return {
      sending: false,
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('dashboard.repairSearch', Object.keys(query).length ? query : {remember: 'forget'}))
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
